<template>
  <vue-aos animation-class="slide-in animated" :threshold="0">
    <div class="services py-5" id="services">
      <div class="text-center">
        <h1 class="underline letter-spacing-md mb-9  text-white">
          What Do We Offer?
        </h1>
        <div class="container">
          <div class="row">
            <div
              class="col-lg-4 col-12 col-md-6 services__col mb-8"
              v-for="(service, index) in services"
              :key="index"
            >
              <div
                class="services__img-container mb-3 position-absolute rounded-circle "
              >
                <img width="100" height="100" :src="service.imgSrc" alt />
              </div>
              <div
                class="card services__service p-lg-3 px-sm-4 px-3 py-3 box-shadow text-center text-sm-left"
              >
                <span class="shinning-border1"></span>
                <span class="shinning-border2"></span>
                <span class="shinning-border3"></span>
                <span class="shinning-border4"></span>

                <div class="services__service__main">
                  <div>
                    <h4 class="mt-lg-6 mt-0 text-center">
                      {{ service.headline }}
                    </h4>
                    <p
                      class="letter-spacing-sm services_description text-center"
                    >
                      {{ service.description }}
                    </p>

                    <!-- <button
                      v-scroll-to="'#contact'"
                      class="btn btn-outline-portfolio4 d-block w-100 d-lg-inline"
                    >
                      Hire US
                    </button> -->
                  </div>
                  <!-- <div
                    class="d-block d-lg-none text-sm-right text-center mb-3 mb-sm-0"
                  >
                    <img
                      class="img-fluid"
                      width="150"
                      height="150"
                      :src="service.imgSrc"
                      alt
                    />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-aos>
</template>

<script>
export default {
  data() {
    return {
      attendants: [
        {
          app: "whatsapp",
          label: "Technical support",
          name: "Alan Ktquez",
          number: "5581983383532",
          avatar: {
            src:
              "https://avatars0.githubusercontent.com/u/8084606?s=460&u=20b6499a416cf7129a18e5c168cf387e159edb1a&v=4",
            alt: "Alan Ktquez avatar",
          },
        },
        // ...
      ],
      services: [
        {
          headline: "Front End Development",
          description:
            "We have converted many designs into front end static websites. We use Vue js as front-end framework for developing the websites. We provide very high quality code for your front-end which is easily maintainable and extendable for your future use.",
          imgSrc: require("../../assets/svgs/design.svg"),
        },
        {
          headline: "Back End Development",
          description:
            "We work on latest technologies like Nodejs and Laravel for our backend development. We use mongodb and mysql databases for our services.",
          imgSrc: require("../../assets/svgs/code.svg"),
        },
        {
          headline: "Bug Fix & Maintenance",
          description:
            "We fix the bugs and issues matching our stack (Html,Css,Javascript,Vue js , Node js, Mongodb , Mysql). We can also do maintainance for your website and also provide support on monthly or yearly basis.",
          imgSrc: require("../../assets/svgs/fix.svg"),
        },
        {
          headline: "Hybrid Mobile App",
          description:
            "We work on IOS and Android hybrid application development. Hybrid apps are easily manageable and cheaper as compared to Native apps.",
          imgSrc: require("../../assets/images/home/services/hybrid.png"),
        },
        {
          headline: "IOS App Development",
          description:
            "If you have larger app then IOS development using Native swift language is a better choice which gives you fast and better performance.",
          imgSrc: require("../../assets/images/home/services/ios.png"),
        },
        {
          headline: "Android App Development",
          description:
            "Despite of better speed and performance native apps provide a recognizable look and feel.If you have higher budget and your target is for the android devices only then Native Android App is better choice.",
          imgSrc: require("../../assets/images/home/services/android.png"),
        },
      ],
    };
  },
};
</script>

<style></style>
